// Open checkout when Shopify's existing payment-options link is clicked.
window.addEventListener('click', (event) => {
  const isPaymentLink = event.composedPath().some(
    (element) => element.id === 'more-payment-options-link'
  );
  if (!isPaymentLink) return;

  event.preventDefault();
  event.stopImmediatePropagation();
  window.location.assign((window.Shopify?.routes?.root || '/') + 'checkout');
}, true);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      
      const modal = document.querySelector(this.getAttribute('data-modal'));
      
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    this.addEventListener('click', (event) =>{
      if (event.target === event.currentTarget) {
        this.hide()
      }
    })
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
   
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
  
  }
}
customElements.define('modal-dialog', ModalDialog);